<template>
  <div class="declarationForm-wp">
    <nav class="title">修链科技留咨页</nav>
    <div class="content-box">
      <ul v-for="item in extFields" :key="item._id">
        <template v-if="item.type == 'text' || item.type == 'phone'">
          <li>
            <span class="cell-title">{{ item.nameDisp }}</span>
            <el-input
              :placeholder="`请输入${item.nameDisp}`"
              type="text"
              v-model="formData[item.name]"
            ></el-input>
          </li>
        </template>
        <template v-if="item.type == 'select' && item.name != 'orderStatus'">
          <template v-if="item.name == 'province'">
            <li style="margin-bottom:0;border-bottom:2px #f7f7f7 solid">
              <span class="cell-title">省市区</span>
            </li>
            <li style="display:flex;padding:0;">
              <el-select
                style="flex:1"
                v-model="formData.province"
                @change="areaPChange(formData.province)"
                placeholder="请选择省"
              >
                <el-option
                  v-for="item in area.provinceList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
              <el-select
                style="flex:1"
                v-model="formData.city"
                @change="areaCChange(formData.city)"
                placeholder="请选择市"
              >
                <el-option
                  v-for="item in area.cityList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
              <el-select style="flex:1" v-model="formData.district" placeholder="请选择区">
                <el-option
                  v-for="item in area.districtList"
                  @change="this.$forceUpdate()"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </li>
          </template>
          <template v-else>
            <li>
              <span class="cell-title">{{ item.nameDisp }}</span>
              <el-select v-model="formData[item.name]" :placeholder="`请选择${item.nameDisp}`">
                <el-option
                  v-for="item in options[item.valueOption]"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </li>
          </template>
        </template>
        <template v-if="item.type == 'datetime'">
          <li>
            <span class="cell-title">{{ item.nameDisp }}</span>
            <el-date-picker
              size="mini"
              v-model="formData[item.name]"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetime"
              placeholder="选择日期时间"
            ></el-date-picker>
          </li>
        </template>
      </ul>
    </div>
    <el-button type="primary" @click="submitBtn">提交</el-button>
    <div class="maskLayer" ref="maskLayer">
      <i class="el-icon-check" style="font-size:22vw;display: block;"></i>
      <span>保存成功！</span>
    </div>
  </div>
</template>

<script>
export default {
  activated() {
    window.$this = this;
  },
  name: 'DeclarationForm',
  data() {
    let that = this;
    window.$this = this;
    return {
      formData: {},
      area: {},
      id: '',
      extFields: [],
      options: {},
      //当前租户信息
      profile: {}
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.id = this.osg.param('id');
      this.userId = this.osg.param('user');
      this.getProvince();
      this.getProfile();
      this.osg.ajax(`s/queryByColName/declaration/${this.id}.do`, {}, res => {
        if (res.entity) {
          this.extFields = res.entity.extFieldList;
          for (var item of res.entity.extFieldList) {
            if (item.valueOption)
              this.options['codecfg_' + item.valueOption] = {
                codeId: item.valueOption
              };
            //级联
            if (item.type == 'cascade')
              this.options['cascadeCode_' + item.valueOption] = {
                codeId: item.valueOption
              };
          }
          this.options['codecfg_tenantId'] = {
            eleid: 'tenantId',
            tenantId: this.id
          };
          this.osg.codeoption(() => {
            this.getData();
          });
        }
      });
    },
    //获取当前租户信息
    getProfile() {
      return new Promise(resolve => {
        this.osg.ajax(`s/find/${this.id}.do`, {}, res => {
          if (res.entity) this.profile = res.entity;
          console.log(this.profile);
          //设置主题色（按钮...）
          this.$util.customizeMenuChange(res.entity.menuBarBgColor);
          //设置浏览器icon图标/title
          document.querySelector('#titleBroswer').innerHTML = !this.profile.browserTitle
            ? '修链科技丨数字化赋能房屋维修'
            : this.profile.browserTitle;
          document.querySelector('#iconTitleBroswer').href = !this.profile.browserIcon
            ? './favicon.ico'
            : this.profile.browserIcon;
        });
        resolve();
      });
    },
    getData() {
      //请求所有的字段
      this.osg.ajax(`s/queryByColName/declaration/${this.id}.do`, {}, res => {
        if (res.entity) {
          this.extFields = res.entity.extFieldList;
          this.extFields = this.extFields.filter(item => {
            if (item.name == 'city' || item.name == 'district') return false;
            return true;
          });
        }
      });
    },
    submitBtn() {
      if (!this.formData.name) {
        this.osg.toast('业主姓名不能为空', 'error');
        return;
      } else if (!this.formData.phone) {
        this.osg.toast('业主手机号不能为空', 'error');
        return;
      } else {
        if (!this.checkMobile(this.formData.phone)) {
          this.osg.toast('业主手机号格式错误', 'error');
          return;
        }
      }
      // if (!this.formData.title) {
      //   this.osg.toast("工单标题不能为空", "error");
      //   return;
      // }
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      this.$refs.maskLayer.style = 'display:block';

      if (this.formData.date1 && this.formData.date2) {
        this.formData.applyTime = this.formData.date1 + ' ' + this.formData.date2;
      }
      delete this.formData.date1;
      delete this.formData.date2;

      this.formData.exts = {};
      this.extFields.forEach(item => {
        if (item.updateUser != 0) {
          this.formData.exts[item.name] = this.formData[item.name];
          delete this.formData[item.name];
        }
      });
      this.formData.tenantId = this.id;
      this.formData.id = this.userId;
      this.osg.ajax(`s/upsert.do`, this.formData, res => {
        if (res.success) {
          this.$refs.maskLayer.style = 'display:block';
          setTimeout(() => {
            // location.reload();
            loading.close();
          }, 1500);
        } else {
          loading.close();
          this.osg.toast('提交失败！请联系管理员！', 'error');
        }
      });
    },
    //验证手机号
    checkMobile(sMobile) {
      if (!/^1[3456789]\d{9}$/.test(sMobile)) {
        return false;
      } else {
        return true;
      }
    },
    areaPChange(id) {
      this.getCity(id);
      delete this.formData.city;
      delete this.formData.district;
    },
    areaCChange(id) {
      delete this.formData.district;
      this.getDistrict(id);
    },
    async getProvince() {
      this.area.provinceList = await this.$util.getProvince();
      this.$forceUpdate();
    },
    async getCity(id) {
      this.area.cityList = await this.$util.getCity(id);
      this.getDistrict(id);
      this.$forceUpdate();
    },
    async getDistrict(id) {
      console.log(this.formData);
      this.area.districtList = await this.$util.getDistrict(id);
      this.$forceUpdate();
    }
  }
};
</script>

<style scoped>
* {
  font-size: 4.2vw;
}
.declarationForm-wp {
  background: #f7f7f7;
  overflow-x: hidden;
}
.title {
  width: 100%;
  height: 9vh;
  background: #545c64;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 600;
  font-size: 5vw;
  color: #fff;
}
.content-box {
  width: 100%;
  flex-direction: column;
}
.content-box ul {
  width: 100%;
  box-sizing: border-box;
}
.content-box ul > li {
  padding: 0 4vw;
  box-sizing: border-box;
  height: 12vw;
  display: flex;
  outline: none;
  border: none;
  justify-content: space-between;
  align-items: center;
  background: #fff;
  margin-bottom: 1.2vh;
}

>>> .el-input__inner {
  border: none;
  font-size: 3.5vw;
  text-align: right;
}
>>> .el-input {
  width: 50vw;
}
.cell-title {
  width: 30vw;
}
footer {
  width: 100%;
}
>>> .el-button {
  width: 100%;
  height: 7vh;
}
>>> .el-textarea__inner {
  outline: none;
  border: none;
  margin-bottom: 1.2vh;
}
.uncheck {
  color: #000;
}
>>> .el-input--suffix {
  width: 30vw;
}
>>> .el-date-editor--datetime {
  width: 50vw;
}
>>> .el-date-picker {
  left: 6vw !important;
  background: Red;
  color: gray;
}
>>> .el-date-editor--datetime {
  width: 50vw;
  margin-right: -4vw;
}
.maskLayer {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #000;
  z-index: 9999;
  width: 50vw;
  height: 32vw;
  color: #fff;
  border-radius: 2vw;
  text-align: center;
  border-radius: 3vw;
  box-shadow: 13px;
  opacity: 0.68;
  display: none;
}
</style>
